module.exports = __webpack_public_path__ + "img/logo-black.4bd2a9b5.svg";